import * as rxjs from 'rxjs';
import apiService, { ApiService } from './api';

export interface ISnapshot {
  id: number;
  month: number;
  year: number;
  day: number;
  createdAt: Date;
}

export class SnaphotService {
  constructor(private apiService: ApiService) {}
  public list(): rxjs.Observable<ISnapshot[]> {
    return this.apiService.get('/dashboard/history', undefined, false, {});
  }
}

const snapshotService = new SnaphotService(apiService);
export default snapshotService;
